import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import {Button} from "primereact/button";
import LinearProgress from "@material-ui/core/LinearProgress";

const Close = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Operación \ Cierre"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Button label={props.labelButton} style={{'float': 'right'}}
                                onClick={props.handleClose}/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            responsive={true}
                            value={props.validationList}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column
                                field="nombreValidacion"
                                header="Proceso"
                                style={{textAlign: 'left'}}
                                sortable={true}/>
                            <Column
                                field="statusValidacion"
                                header="Estatus"
                                style={{textAlign: 'center', width: '20%'}}
                                body={props.formatStatus}
                                sortable={true}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default Close;